var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Pc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 47h33v4h-6v9h6v4H25v-4h11v-9H13a4 4 0 01-4-4V19a4 4 0 014-4h50a4 4 0 014 4v8h-4v-8H13v28zm56-12.77v26.54A3.23 3.23 0 0165.77 64H53.23A3.24 3.24 0 0150 60.77V34.23A3.24 3.24 0 0153.23 31h12.54A3.23 3.23 0 0169 34.23zm-7.5 23a2 2 0 10-4 0 2 2 0 004 0zM65 43.5a1.5 1.5 0 00-1.5-1.5h-8a1.5 1.5 0 100 3h8a1.5 1.5 0 001.5-1.5zm0-6a1.5 1.5 0 00-1.5-1.5h-8a1.5 1.5 0 100 3h8a1.5 1.5 0 001.5-1.5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_PC.fb1ff234.svg";
export { SvgH1Pc as ReactComponent };